var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

import * as React from 'react';
import { CompositeDecorator, EditorState } from 'draft-js';

import DraftJSMentionSelectorCore from './DraftJSMentionSelectorCore';
import DraftMentionItem from './DraftMentionItem';
import FormInput from '../form/FormInput';
import * as messages from '../input-messages';

/**
 * Scans a Draft ContentBlock for entity ranges, so they can be annotated
 * @see docs at {@link https://draftjs.org/docs/advanced-topics-decorators.html#compositedecorator}
 * @param {ContentBlock} contentBlock
 * @param {function} callback
 * @param {ContentState} contentState
 */
var mentionStrategy = function mentionStrategy(contentBlock, callback, contentState) {
    contentBlock.findEntityRanges(function (character) {
        var entityKey = character.getEntity();

        var ret = entityKey !== null && contentState.getEntity(entityKey).getType() === 'MENTION';
        return ret;
    }, callback);
};

// babel-plugin-flow-react-proptypes doesn't understand imported types

var DraftJSMentionSelector = function (_React$Component) {
    _inherits(DraftJSMentionSelector, _React$Component);

    function DraftJSMentionSelector(props) {
        _classCallCheck(this, DraftJSMentionSelector);

        var _this = _possibleConstructorReturn(this, (DraftJSMentionSelector.__proto__ || Object.getPrototypeOf(DraftJSMentionSelector)).call(this, props));

        _this.handleBlur = function (event) {
            if (_this.props.validateOnBlur && _this.containerEl && event.relatedTarget instanceof Node && !_this.containerEl.contains(event.relatedTarget)) {
                _this.checkValidity();
            }

            _this.setState({ hasReceivedFirstInteraction: true });
        };

        _this.handleFocus = function (event) {
            var onFocus = _this.props.onFocus;


            if (onFocus) {
                onFocus(event);
            }
        };

        _this.handleChange = function (nextEditorState) {
            var internalEditorState = _this.state.internalEditorState;
            var onChange = _this.props.onChange;


            if (internalEditorState) {
                _this.setState({
                    internalEditorState: nextEditorState
                }, function () {
                    if (onChange) {
                        onChange(nextEditorState);
                    }
                    _this.checkValidity();
                });
            } else {
                if (onChange) {
                    onChange(nextEditorState);
                }
                _this.checkValidity();
            }
        };

        _this.handleValidityStateUpdateHandler = function () {
            if (!_this.state.hasReceivedFirstInteraction) {
                return;
            }

            var error = _this.getErrorFromValidityState();

            _this.setState({ error: error });
        };

        _this.checkValidity = function () {
            _this.handleValidityStateUpdateHandler();
        };

        var mentionDecorator = new CompositeDecorator([{
            strategy: mentionStrategy,
            component: DraftMentionItem
        }]);

        // @NOTE (smotraghi 2017-05-30):
        // This component might be either own its EditorState (in which case it lives in `this.state.internalEditorState`)
        // or be a controlled component whose EditorState is passed in via the `editorState` prop.
        // If `props.editorState` is set, `internalEditorState` is `null`,
        // otherwise we initialize it here
        _this.state = {
            contacts: [],
            hasReceivedFirstInteraction: false,
            internalEditorState: props.editorState ? null : EditorState.createEmpty(mentionDecorator),
            error: null
        };
        return _this;
    }

    /**
     * Lifecycle method that gets called when a component is receiving new props
     * @param {object} nextProps Props the component is receiving
     * @returns {void}
     */


    _createClass(DraftJSMentionSelector, [{
        key: 'componentWillReceiveProps',
        value: function componentWillReceiveProps(nextProps) {
            var _this2 = this;

            var contacts = nextProps.contacts;


            if (contacts) {
                this.setState({ contacts: contacts }, function () {
                    _this2.checkValidity();
                });
            }
        }

        /**
         * @returns {string}
         */

    }, {
        key: 'getErrorFromValidityState',
        value: function getErrorFromValidityState() {
            var _props = this.props,
                externalEditorState = _props.editorState,
                isRequired = _props.isRequired,
                maxLength = _props.maxLength,
                minLength = _props.minLength;
            var internalEditorState = this.state.internalEditorState;

            // manually check for content length if isRequired is true

            var editorState = internalEditorState || externalEditorState;
            var length = editorState.getCurrentContent().getPlainText().trim().length;

            if (isRequired && !length) {
                return messages.valueMissing();
            }

            if (typeof minLength !== 'undefined' && length < minLength) {
                return messages.tooShort(minLength);
            }

            if (typeof maxLength !== 'undefined' && length > maxLength) {
                return messages.tooLong(maxLength);
            }

            return null;
        }

        /**
         * Event handler called on blur. Triggers validation
         * @param {SyntheticFocusEvent} event The event object
         * @returns {void}
         */


        /**
         * Updates editorState, rechecks validity
         * @param {EditorState} nextEditorState The new editor state to set in the state
         * @returns {void}
         */

    }, {
        key: 'render',
        value: function render() {
            var _this3 = this;

            var _props2 = this.props,
                _props2$className = _props2.className,
                className = _props2$className === undefined ? '' : _props2$className,
                externalEditorState = _props2.editorState,
                hideLabel = _props2.hideLabel,
                isDisabled = _props2.isDisabled,
                isRequired = _props2.isRequired,
                label = _props2.label,
                mentionTriggers = _props2.mentionTriggers,
                name = _props2.name,
                onMention = _props2.onMention,
                placeholder = _props2.placeholder,
                selectorRow = _props2.selectorRow,
                startMentionMessage = _props2.startMentionMessage,
                onReturn = _props2.onReturn;
            var _state = this.state,
                contacts = _state.contacts,
                internalEditorState = _state.internalEditorState,
                error = _state.error;
            var handleBlur = this.handleBlur,
                handleChange = this.handleChange,
                handleFocus = this.handleFocus;

            var editorState = internalEditorState || externalEditorState;

            return React.createElement(
                'div',
                {
                    className: className,
                    ref: function ref(containerEl) {
                        _this3.containerEl = containerEl;
                    }
                },
                React.createElement(
                    FormInput,
                    {
                        name: name,
                        onValidityStateUpdate: this.handleValidityStateUpdateHandler
                    },
                    React.createElement(DraftJSMentionSelectorCore, {
                        contacts: contacts,
                        editorState: editorState,
                        error: error,
                        hideLabel: hideLabel,
                        isDisabled: isDisabled,
                        isRequired: isRequired,
                        label: label,
                        mentionTriggers: mentionTriggers,
                        onBlur: handleBlur,
                        onChange: handleChange,
                        onFocus: handleFocus,
                        onMention: onMention,
                        onReturn: onReturn,
                        placeholder: placeholder,
                        selectorRow: selectorRow,
                        startMentionMessage: startMentionMessage
                    })
                )
            );
        }
    }]);

    return DraftJSMentionSelector;
}(React.Component);

DraftJSMentionSelector.defaultProps = {
    isRequired: false,
    validateOnBlur: true
};
DraftJSMentionSelector.propTypes = {
    className: PropTypes.string,
    contacts: PropTypes.arrayOf(PropTypes.shape({
        id: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
        name: PropTypes.string.isRequired
    })).isRequired,
    editorState: function editorState() {
        return (typeof EditorState === 'function' ? PropTypes.instanceOf(EditorState) : PropTypes.any).apply(this, arguments);
    },
    hideLabel: PropTypes.bool,
    isDisabled: PropTypes.bool,
    isRequired: PropTypes.bool,
    label: PropTypes.node.isRequired,
    mentionTriggers: PropTypes.arrayOf(PropTypes.string),
    maxLength: PropTypes.number,
    minLength: PropTypes.number,
    name: PropTypes.string.isRequired,
    onChange: PropTypes.func,
    onFocus: PropTypes.func,
    onMention: PropTypes.func.isRequired,
    onReturn: PropTypes.func,
    placeholder: PropTypes.string,
    selectorRow: PropTypes.node,
    startMentionMessage: PropTypes.node,
    validateOnBlur: PropTypes.bool
};


export default DraftJSMentionSelector;
import PropTypes from 'prop-types';